module.exports = __webpack_public_path__ + "static/media/Fuel icon (1).179ee883.svg";